const METERS_TO_KM_RATIO = 0.001
const METERS_TO_MILES_RATIO = 0.000621371

export const convertMetersToKiloMeters = (distance) =>
  Math.floor(distance * METERS_TO_KM_RATIO)
export const convertMetersToMiles = (distance) =>
  Math.floor(distance * METERS_TO_MILES_RATIO)
